<template>
  <div>
    <hshead title="摄影师管理" waveBg="true"></hshead>
    <div class="tabs-box">
      <van-tabs v-model="tabactive" swipeable title-active-color="#007dfa" color="#007dfa">
        <van-tab title="摄影师名下">
          <div class="city-top">
            <div class="top-left">
              <div class="this-p">已通过：10</div>
              <div class="this-p">审核中：2</div>
            </div>
            <div class="top-right">
              <div class="this-img">
                <img src="../assets/images/city/p.png" alt />
              </div>
              <router-link to class="this-btn">共有摄影师</router-link>
            </div>
          </div>
          <div class="city-ul">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <div class="city-li" v-for="(item, index) in list" :key="index">
                <div class="left-icon">
                  <img src="../assets/images/city/p-b.png" style="width:0.8rem" alt />
                </div>
                <div class="center-p">
                  <div class="center-h1">玛丽</div>
                  <div class="center-time">2018-05-01 22:09</div>
                </div>
                <div class="right-icon" v-if="false">
                  <img src="../assets/images/city/icon.png" alt />
                </div>
                <div class="right-btn-box">
                  <div class="right-btn primary">审核通过</div>
                  <div class="right-btn danger">审核不通过</div>
                </div>
              </div>
            </van-list>
          </div>
        </van-tab>
        <van-tab title="约拍城市审核">
          <div class="city-top">
            <div class="top-left">
              <div class="this-p">已通过：10</div>
              <div class="this-p">审核中：2</div>
            </div>
            <div class="top-right">
              <div class="this-img">
                <img src="../assets/images/city/city.png" alt />
              </div>
              <router-link to class="this-btn">已有城市</router-link>
            </div>
          </div>
          <div class="city-ul">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <div class="city-li" v-for="(item, index) in list" :key="index">
                <div class="left-icon">
                  <img src="../assets/images/city/tempCity.png" alt />
                </div>
                <div class="center-p">
                  <div class="center-h1">广东省广东市</div>
                  <div class="center-time">2018-05-01 22:09</div>
                </div>
                <div class="right-icon">
                  <img src="../assets/images/city/icon.png" alt />
                </div>
              </div>
            </van-list>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item to="/MissionHall" icon="todo-list-o">任务中心</van-tabbar-item>
      <van-tabbar-item icon="chart-trending-o">收益</van-tabbar-item>
      <van-tabbar-item icon="manager-o">摄影师</van-tabbar-item>
      <van-tabbar-item icon="orders-o">商品管理</van-tabbar-item>
      <van-tabbar-item icon="apps-o">更多</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Tab, Tabs, List,Tabbar, TabbarItem  } from "vant";
export default {
  name: "photographer",
  data() {
    return {
      list: [],
      tabactive: 0,
      active: 2,
      loading: false,
      finished: false
    };
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    }
  },
  components: {
    hshead,
    "van-list": List,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.tabs-box {
  margin-top: -4.3rem;
}
.city-top {
  display: flex;
  margin-top: 0.3rem;
  .top-left {
    width: 3.41rem;
    height: 1.04rem;
    border-right: 1px solid rgba(255, 255, 255, 0.6);
    .this-p {
      font-family: PingFang-SC-Medium;
      font-size: 0.3rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #ffffff;
      padding-left: 1rem;
      padding-top: 0.15rem;
    }
  }
  .top-right {
    flex: 1;
    display: flex;
    .this-img {
      width: 1.9rem;
      text-align: center;
      img {
        width: 0.83rem;
        height: 0.87rem;
        display: inline-block;
      }
    }
    .this-btn {
      display: block;
      text-align: center;
      margin-top: 0.3rem;
      width: 1.65rem;
      height: 0.51rem;
      border-radius: 0.06rem;
      font-family: PingFang-SC-Medium;
      font-size: 0.24rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.51rem;
      letter-spacing: 0rem;
      color: #fff;
    }
  }
}
.city-ul {
  margin-top: 0.9rem;
  margin-bottom: 1rem;
  .city-li {
    width: 6.7rem;
    height: 2.01rem;
    background-color: #fff;
    box-shadow: 0rem 0.01rem 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.06rem;
    display: flex;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    .left-icon {
      width: 2.08rem;
      text-align: center;
      padding-top: 0.4rem;
      img {
        width: 1.17rem;
        height: auto;
        display: inline-block;
      }
    }
    .center-p {
      width: 3.48rem;
      padding-top: 0.4rem;
      .center-h1 {
        font-family: PingFang-SC-Medium;
        font-size: 0.28rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0.01rem;
        color: #333333;
        padding-bottom: 0.35rem;
      }
      .center-time {
        font-family: PingFang-SC-Medium;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0.01rem;
        color: #808d9e;
      }
    }

    .right-icon {
      width: 0.9rem;
      padding-top: 0.14rem;
      img {
        width: 0.9rem;
        height: 0.89rem;
      }
    }
    .right-btn-box {
      margin-top: 0.4rem;
      .right-btn {
        width: 1.4rem;
        height: 0.5rem;
        line-height: 0.5rem;
        text-align: center;
        color: #fff;
        background: #000;
        font-size: 0.24rem;
        margin-bottom: 0.2rem;
        margin-right: 0.1rem;
        border-radius: 0.2rem;
        &.primary {
          background: #07c160;
        }
        &.danger {
          background: #f44;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/photographer.vue